<template>
  <ProtocolEditComponent
    :local="true"
    :new="true"
    :id="this.$route.params.id"
  />
</template>

<script>
import ProtocolEditComponent from '../../components/protocols/ProtocolEditComponent'
export default {
  name: 'LocalProtocolNew',
  components: {ProtocolEditComponent}
}
</script>



// WEBPACK FOOTER //
// src/views/local/ProtocolNew.vue